import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';

import store from '../redux/store';

import { apiSetup } from '~config/api';
import Theme from '~config/MaterialUIStyles/Theme';
import { isGDPRCountry } from '~utils/cookieSettings';

import Routes from './components/Routes';
import ErrorBoundary from './components/ErrorBoundary/index';
import { loadAnalyticsScripts, renderHeadAnalyticsScripts, hasAnalyticsConsent } from './utils';
import { StructuredData } from './components/StructuredData';

class App extends Component {
  componentDidMount() {
    apiSetup(store.dispatch);
    loadAnalyticsScripts();
  }

  render() {
    return (
      <ThemeProvider theme={Theme}>
        {(hasAnalyticsConsent() || !isGDPRCountry()) && renderHeadAnalyticsScripts()}
        <Provider store={store}>
          <StructuredData />
          <ErrorBoundary>
            <Routes />
          </ErrorBoundary>
        </Provider>
      </ThemeProvider>
    );
  }
}

App.defaultProps = {
  loading: false
};

export default App;
